import React, {useRef} from "react"
import RadioButton from "../../components/RadioButton"
import styles from "./RadioCardGroup.module.css"

const RadioCardGroup = ({ options=[], selectedValue="", onChange=()=>{} }) => {
    // Create an array of refs
    const inputRefs = useRef([]);
    return (
        <div className="card-group">
            {
                options.map((option, index) => {
                    const {id, isInactive, editable, label, description, right, left} = option || {}
                    // Ensure there's a ref for each option
                    if (!inputRefs.current[index]) {
                        inputRefs.current[index] = React.createRef();
                    }
                    return (
                        <div
                            key={id ?? index}
                            className={[
                                `card justify-content-space-between align-items-center ${styles.option}`,
                                selectedValue === id ? "selected" : "",
                                isInactive ? "inactive" : ""
                            ].join(" ")}
                        >
                            <div 
                                className="display-flex flex-1 align-items-center"
                                onClick={() => {
                                    const ref = inputRefs.current[index];
                                    if (ref?.current) {
                                        ref.current.click();
                                    }
                                }}
                            >
                                <RadioButton
                                    inputRef={inputRefs.current[index]}
                                    checked={selectedValue === id}
                                    editable={editable ?? true}
                                    isActive={!isInactive}
                                    onChange={() => onChange(id)}
                                >
                                    <div  className="display-flex align-items-center">
                                        {left && <div className="margin-right-5px">{left}</div>}
                                        <div className="display-flex flex-direction-column margin-left-05em">
                                            <span className="font-size-16px font-weight-500">{label}</span>
                                            {description && (
                                                <span className="font-size-14px color-dark-grey margin-top-2px">{description}</span>
                                            )}
                                        </div>
                                    </div>
                                </RadioButton>
                            </div>

                            {right && (
                                <div className={`display-flex align-items-center margin-left-5px ${styles.right}`}>
                                    {right}
                                </div>
                            )}
                        </div>
                    )
                })
            }
        </div>
    )
}

export default RadioCardGroup